import { GetterTree } from 'vuex';
import { DocumentsState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<DocumentsState, RootState> = {
  personalDocuments: (state, getters) => {
    return state.personalDocuments;
  },
  sponsorDocuments: (state, getters) => {
    return state.sponsorDocuments;
  },
};

export default getters;
